import type { ReactNode } from "react";
import { Button } from "../button";
import { Icon, IconAlertTriangle, type TablerIcon } from "../icon";
import { cx } from "../tv";

/** One sentence, one primary action and presets; never a blank area (DESIGN-RULES 9). */
export function EmptyState({ icon, title, body, action, presets, className }: {
  icon?: TablerIcon; title: string; body?: string; action?: ReactNode; presets?: ReactNode; className?: string;
}) {
  return (
    <div data-state="empty" className={cx("grid flex-1 place-items-center p-8", className)}>
      <div className="flex max-w-[420px] flex-col items-center gap-3 text-center">
        {icon && <span className="grid size-12 place-items-center rounded-xl bg-accent-subtle text-accent"><Icon icon={icon} size="rail" /></span>}
        <h2 className="font-title text-2xl">{title}</h2>
        {body && <p className="text-md text-fg-muted">{body}</p>}
        {action}
        {presets && <div className="mt-1 flex flex-wrap justify-center gap-2">{presets}</div>}
      </div>
    </div>
  );
}

/** Plain-language error with a retry, never a raw code (DESIGN-RULES 9). */
export function ErrorState({ title, body, retryLabel, onRetry, className }: { title: string; body: string; retryLabel: string; onRetry: () => void; className?: string }) {
  return (
    <div role="alert" data-state="error" className={cx("grid flex-1 place-items-center p-8", className)}>
      <div className="flex max-w-[420px] flex-col items-center gap-3 text-center">
        <span className="grid size-12 place-items-center rounded-xl bg-danger-subtle text-danger"><Icon icon={IconAlertTriangle} size="rail" /></span>
        <h2 className="font-title text-2xl">{title}</h2>
        <p className="text-md text-fg-muted">{body}</p>
        <Button onPress={onRetry}>{retryLabel}</Button>
      </div>
    </div>
  );
}
